/*
 * @Author: your name
 * @Date: 2020-07-30 20:39:54
 * @LastEditTime: 2021-01-28 11:14:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/vender/form-schema-config/components/form-upload.config.js
 */
import apis from '../../../api/index'
import Vue from 'vue'
import axios from 'axios'
const FromUploadConfig = {
  // 类型
  componentType: 'FORM_FILE_UPLOAD',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-upload',
    text: '附件上传',
    optionTitle: false,
    description: '通过点击或者拖拽上传文件，单个文件最大100M'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 12,
    render: {
      ide: 'FormUpload',
      edit: 'FormUpload',
      read: 'FormUpload'
    },
    noBorder: true,
    label: '附件上传',
    fileMaxNum: -1,
    fileMaxSize: 100,
    fileDisplayType: 'block',
    fileType: ['all'],
    abort: {},
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcGetImgSrc(...args) {
        let file = args[args.length - 1]
        const params = Vue.prototype.$base64.encode(JSON.stringify({
          xdaptenantid: file.tenantId,
          xdaptoken: Vue.prototype.$axios.defaults.headers.xdaptoken
        }))
        return file.url && `${file.url}&token=${params}`
      },
      lcPostUpload(...args) {
        let file = args[args.length - 1]
        let formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('uploadId', Date.now())
        return new Promise((resolve, reject) => {
          const request = { ...apis.COMPONENT.FORM_UPLOAD_CONFIG_API }
          request.params = formData
          const CancelToken = axios.CancelToken
          const that = this
          request.cancelToken = new CancelToken(function executor(c) {
            that.widget.abort[file.uuid] = c
          })
          Vue.prototype.$upload(request).asyncThen((resp) => {
            resolve(resp.data)
          }, (err) => {
            reject(err)
          }).asyncErrorCatch((err) => {
            reject(err)
          })
        })
      },
      lcRemoveUpload(...args) {
        let file = args[args.length - 1]
        return new Promise((resolve, reject) => {
          const request = { ...apis.COMPONENT.FORM_UPLOAD_CONFIG_DELETE }
          request.params = {
            file: file.id
          }
          Vue.prototype.$request(request).asyncThen((resp) => {
            resolve(resp)
          }, (err) => {
            reject(err)
          }).asyncErrorCatch((err) => {
            reject(err)
          })
        })
      }
    }
  },
  editorConfig: [
    'INFO',
    'LABEL',
    'UPLOADSIZE',
    'UPLOADSHOWTYPE',
    'UPLOADLIMIT',
    'UPLOADFILETYPE',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW'
  ]
}

export default FromUploadConfig
